<template>
  <main class="prizes bb">
    <section>
      <PageBackButton />

      <h1 class="pg_title">{{ $_translations.value.page_prizes_title }}</h1>

      <h2 class="subtitle">
        {{ $_translations.value.page_prizes_subtitle_pt1 }}
        <b>{{ $_translations.value.page_prizes_subtitle_pt2 }}</b>
      </h2>

      <template v-if="!fetching">
        <PrizeItem
          v-for="prize in prizeList"
          :key="prize.type"
          :item="prize"
          @show:howToWin="openHowToWinModal"
        />
      </template>
    </section>
  </main>

  <HowToWinModal v-if="isHowToWinModalOpen" />
</template>

<script setup>
import { onMounted, ref } from 'vue';
import PageBackButton from '@/components/button/PageBackButton.vue';
import PrizeItem from '@/views/prizes/components/PrizeItem.vue';
import HowToWinModal from '@/views/prizes/components/HowToWinModal.vue';
import useLocaleStore from '@/store/modules/locale.js';
import useModalHook from '@/hooks/useModal.js';
import { retrievePrizes } from '@/services/prizes.js';

const localeStore = useLocaleStore();

const [isHowToWinModalOpen, openHowToWinModal] = useModalHook();

const fetching = ref(false);
const prizeList = ref([]);

onMounted(async () => {
  try {
    fetching.value = true;

    const { data } = await retrievePrizes(localeStore.currentLanguage);

    prizeList.value = data;

    fetching.value = false;
  } catch {
    fetching.value = false;
  }
});
</script>
